import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";

export default function useLeads() {

  const [leads, setLeads] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState(null);

  // ================= FETCH LEADS =================
  const fetchLeads = async () => {

    try {

      setLoading(true);

      const response =
        await axiosInstance.get(
          "/leads"
        );

      setLeads(
        response.data.data || []
      );

    } catch (err) {

      console.log(err);

      setError(err);

    } finally {

      setLoading(false);

    }
  };

  // ================= INITIAL FETCH =================
  useEffect(() => {
    fetchLeads();
  }, []);

  return {
    leads,
    loading,
    error,
    fetchLeads,
    setLeads,
  };
}